// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mu-0";
export var buttonContainer = "_mu-3";
export var cancelButton = "_mu-4";
export var headerSection = "_mu-6";
export var headerTitle = "_mu-9";
export var messageSideLeft = "_mu-1";
export var messageSideRight = "_mu-2";
export var orderNumberContainer = "_mu-7";
export var orderNumberLabel = "_mu-8";
export var submitButton = "_mu-5";